import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { useCollapseContext } from '../context/collapse-context';
import { collapseAnimation } from '../helpers/collapse.animations';

export const CollapseBody = (props) => {
    const { children, className, ...rest } = props;

    const { expanded } = useCollapseContext();

    return (
        <AnimatePresence initial={false} mode="wait">
            {expanded && (
                <motion.div
                    {...rest}
                    {...collapseAnimation}
                    aria-expanded={expanded}
                    className={twMerge('overflow-hidden', className)}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CollapseBody;
